import React, { useEffect } from 'react'
import { connect } from "react-redux";
import { Col, Row } from "reactstrap";

// components
import NewItem from "../../../components/buttons/newItem";
import TypeXpecialList from "./_list";
import TypeXpecialForm from "./_form";
import { showLoader } from "../../../components/loader/loader";

// actions
import { setApp, clearState as clearMainState } from '../../../redux/actions/generalActions/mainActions'
import { clearState as clearListState } from '../../../redux/actions/generalActions/listActions'

const TypeXpecial = props => {
    const { loading, viewMode } = props?.mainState

    useEffect(() => {
        if (props.app !== null)
            props.setApp(props.app);

        return () => {
            props.clearMainState()
            props.clearListState()
        }
    },[])

    return <>
        { loading && showLoader() }

        <NewItem />

        <Row>
            <Col>
                {(
                    function (){
                        switch (viewMode){
                            case 'FORM':
                                return <TypeXpecialForm />
                            default:
                                return <TypeXpecialList />
                        }
                    }
                )()}
            </Col>
        </Row>
    </>
}

const mapStateToProps = state => ({
    mainState: state.mainProps,
})
const mapActionsToProps = ({
    setApp,
    clearMainState,
    clearListState,
})

export default connect(mapStateToProps, mapActionsToProps)(TypeXpecial)